.tooltip {
  position: relative;
  display: inline-block;
}

:host {
  --uui-tooltip-text-color: var(--uui-theme-on-core-700);
  --uui-tooltip-background-color: var(--uui-theme-variant-200);
  --uui-tooltip-position: calc(100% + 10px);
}

.tooltiptext {
  font-family: var(--uui-primary-font-family);
  font-size: var(--uui-extra-small-font-size);
  line-height: var(--uui-extra-small-line-height);
  font-weight: var(--uui-font-weight-normal);
  background-color: var(--uui-tooltip-background-color);
  color: var(--uui-tooltip-text-color);
  text-align: center;
  border-radius: 6px;
  padding: var(--uui-x-small-padding) var(--uui-medium-padding);
  visibility: hidden;
  width: var(--uui-tooltip-width);
  position: absolute;
  z-index: 1;
  top: 0;
}

.tooltip .tooltiptext-top {
  bottom: var(--uui-tooltip-position);
  left: 50%;
  margin-left: -60px;
}

.tooltip .tooltiptext-bottom {
  top: var(--uui-tooltip-position);
  left: 50%;
  margin-left: -60px;
}

.tooltip .tooltiptext-left {
  right: var(--uui-tooltip-position);
}

.tooltip .tooltiptext-right {
  left: var(--uui-tooltip-position);
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
}

.tooltip .tooltiptext-top::after {
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: var(--uui-tooltip-background-color) transparent transparent
    transparent;
}

.tooltip:hover .tooltiptext-top {
  visibility: visible;
}

.tooltip .tooltiptext-bottom::after {
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent var(--uui-tooltip-background-color)
    transparent;
}

.tooltip:hover .tooltiptext-bottom {
  visibility: visible;
}

.tooltip .tooltiptext-left::after {
  top: 50%;
  left: 100%;
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent transparent
    var(--uui-tooltip-background-color);
}

.tooltip:hover .tooltiptext-left {
  visibility: visible;
}

.tooltip .tooltiptext-right::after {
  top: 50%;
  right: 100%;
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent var(--uui-tooltip-background-color) transparent
    transparent;
}

.tooltip:hover .tooltiptext-right {
  visibility: visible;
}
